import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import useMilestoneEvents from '@/hooks/runner/events/useMilestoneEvents';
import { usePipelineSummary } from '@/hooks/usePipelineSummary';

export interface FeatureDecorator {
	count: number;
	hasUnseen: boolean;
}

export function useFeatureDecorators(): Record<string, FeatureDecorator> {
	const { milestoneEvents } = useMilestoneEvents();
	const pipelineSummary = usePipelineSummary();
	const userId = useSelector(
		(state: { auth: { user?: { _id?: string } } }) =>
			state.auth?.user?._id,
	);

	return useMemo(() => {
		const decorators: Record<string, FeatureDecorator> = {};

		if (milestoneEvents) {
			const incompleteCount = milestoneEvents.filter(
				(e: any) => !e.isCompleted,
			).length;
			const hasUnseen = userId
				? milestoneEvents.some(
						(e: any) => !e._seenByUsers?.includes(userId),
					)
				: false;

			if (incompleteCount > 0 || hasUnseen) {
				decorators['today'] = { count: incompleteCount, hasUnseen };
			}
		}

		if (pipelineSummary) {
			const { assignedActiveCount, hasUnseen } = pipelineSummary;
			if (assignedActiveCount > 0 || hasUnseen) {
				decorators['pipeline'] = {
					count: assignedActiveCount,
					hasUnseen,
				};
			}
		}

		return decorators;
	}, [milestoneEvents, pipelineSummary, userId]);
}
